import { render, staticRenderFns } from "./PointNetridecashConfirm.vue?vue&type=template&id=25d5790d"
import script from "./PointNetridecashConfirm.vue?vue&type=script&lang=js"
export * from "./PointNetridecashConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports